// Cursor pagination. The one collection envelope (spec/08-api-design.md §2.3 and §2.4).
//
// Single resources are returned bare, so the type is the resource. Only collections are wrapped,
// and they are wrapped like this and no other way.
import { z } from "../zod.js";
/** `?cursor=&limit=`; default 25, maximum 100. No offset pagination on large lists. */
export const PAGE_DEFAULT_LIMIT = 25;
export const PAGE_MAX_LIMIT = 100;
export const PageSchema = z
    .object({
    /** The cursor to pass as `?cursor=` for the next page; `null` on the last one. */
    cursor: z.string().min(1).nullable(),
    hasMore: z.boolean(),
    /** How many items are in `data` on this page — not the size of the whole collection. */
    count: z.int().min(0).max(PAGE_MAX_LIMIT),
})
    .openapi('Page', { description: 'Cursor pagination state for a collection response.' });
/** The query parameters every paginated endpoint accepts. Unknown parameters are rejected (§2.4). */
export const PageQuerySchema = z
    .object({
    cursor: z.string().min(1).optional().openapi({ description: 'The `page.cursor` from the previous response.' }),
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(PAGE_MAX_LIMIT)
        .default(PAGE_DEFAULT_LIMIT)
        .openapi({ description: `Items per page, 1–${PAGE_MAX_LIMIT}.` }),
})
    .openapi('PageQuery');
/**
 * Wrap an item schema in the collection envelope:
 * `{ "data": [ … ], "page": { "cursor": "…", "hasMore": true, "count": 25 } }`.
 */
export function paginated(item, componentName) {
    const schema = z.object({ data: z.array(item), page: PageSchema });
    return componentName ? schema.openapi(componentName) : schema;
}
//# sourceMappingURL=page.js.map